import React, { useContext, useEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { AdminContext } from '../../../../context/admin-context';
import { AdminNavIcon } from '../../../containers/admin/admin-nav-icon';
import EventItem from './event-item';
import { groupAdminEventsByDay } from './group-events-by-day';
import './event-item-style.css';

const EventsList = ({ menuOpen, eventsOpen, panelHeight, panelTop, portalRoot, onToggle, onClose, onNavigate }) => {
  const { events } = useContext(AdminContext);
  const unseenCount = parseInt(events.unseenCount, 10) || 0;
  const eventDayGroups = useMemo(() => groupAdminEventsByDay(events.list), [events.list]);

  useEffect(() => {
    if (!menuOpen) {
      onClose();
    }
  }, [menuOpen, onClose]);

  const handleNavigate = () => {
    onClose();
    if (onNavigate) {
      onNavigate();
    }
  };

  const panelStyle = {};
  if (panelHeight != null) {
    panelStyle.height = `${panelHeight}px`;
  }
  if (panelTop != null) {
    panelStyle.top = `${panelTop}px`;
    panelStyle.maxHeight = `calc(100vh - ${panelTop}px - 16px)`;
  }

  const eventsPanel =
    menuOpen && eventsOpen ? (
      <aside
        id="admin-nav-events-panel"
        className="admin-nav-events-panel is-open"
        aria-label="رویدادها"
        style={panelStyle}
      >
        <div className="admin-nav-events-panel-header">
          <span className="admin-nav-events-panel-title">رویدادها</span>
          <button type="button" className="admin-nav-panel-close" onClick={onClose} aria-label="بستن لیست رویدادها">
            <AdminNavIcon name="close" size={18} className="admin-nav-panel-close-icon" />
          </button>
        </div>

        <div className="admin-nav-events-panel-body">
          {events.list.length === 0 ? (
            <p className="admin-nav-events-empty">رویداد جدیدی نیست.</p>
          ) : (
            <div className="admin-nav-events-groups">
              {eventDayGroups.map((group) => (
                <section key={group.dayKey} className="admin-event-day-group" aria-label={group.label}>
                  <h3 className="admin-event-day-heading">{group.label}</h3>
                  <ul className="list-group admin-nav-events-list">
                    {group.items.map((item) => (
                      <EventItem
                        data={item}
                        key={`${item.section}-${item.id}-${item.section_dependency}`}
                        onNavigate={handleNavigate}
                      />
                    ))}
                  </ul>
                </section>
              ))}
            </div>
          )}
        </div>

        <div className="admin-nav-events-panel-footer">
          <button type="button" className="admin-nav-events-close-btn" onClick={onClose}>
            بستن لیست
          </button>
        </div>
      </aside>
    ) : null;

  return (
    <>
      <button
        type="button"
        className={'admin-nav-item admin-nav-item--events' + (eventsOpen ? ' is-active' : '')}
        onClick={onToggle}
        aria-expanded={eventsOpen}
        aria-controls="admin-nav-events-panel"
      >
        <span className="admin-nav-item-icon admin-nav-events-icon">
          {unseenCount > 0 && (
            <div className="toggle-badge align-items-center justify-content-center">
              <div>{events.unseenCount}</div>
            </div>
          )}
          <AdminNavIcon name="activity" size={20} />
        </span>
        <span className="admin-nav-item-label">رویدادها</span>
        {unseenCount > 0 && <span className="admin-nav-item-meta">{events.unseenCount} جدید</span>}
      </button>

      {eventsPanel && portalRoot && portalRoot.current ? createPortal(eventsPanel, portalRoot.current) : null}
    </>
  );
};

export default EventsList;
